import {
	Inline,
	ResponsiveLayout,
	Text3,
	Touchable,
	IconChevronDownRegular,
	IconChevronUpRegular,
	skinVars,
	Box,
	Text2,
} from "@telefonica/mistica";
import React from "react";

interface IProps {
	title: string;
	text: string[] | string;
	isOpen: boolean;
	index: number;
	itemTaggin?(itemTitle: string): void;
	onItemClick(index: number): void;
}

export const Accordeon: React.FC<IProps> = (props) => {
	const { title, text, index, isOpen, itemTaggin, onItemClick } = props;

	const onPress = (): void => {
		if (itemTaggin) {
			itemTaggin(title);
		}
		onItemClick(index);
	};

	return (
		<ResponsiveLayout fullWidth className="accordeon-container">
			<Touchable onPress={onPress}>
				<Box>
					<Inline space="between" className="accoderon-text-wrapper" fullWidth>
						<Text3 regular>{title}</Text3>
						{isOpen ? (
							<Box paddingLeft={16}>
								<IconChevronUpRegular color={"#666666"} size={16} />
							</Box>
						) : (
							<Box paddingLeft={16}>
								<IconChevronDownRegular color={"#666666"} size={16} />
							</Box>
						)}
					</Inline>
				</Box>
			</Touchable>
			{isOpen && (
				<Box paddingTop={16}>
					{typeof text === "string" ? (
						<Text3 regular color="#86888C">
							{text}
						</Text3>
					) : (
						text.map((line, index) => (
							<Box key={line}>
								<Text3 regular color="#86888C">
									{line}
								</Text3>
								{index < text.length - 1 && <br />}
							</Box>
						))
					)}
				</Box>
			)}
		</ResponsiveLayout>
	);
};
